import { trackEvent } from 'lib/ui-analytics';
import { createUserInteraction } from '../utils';
import {
  TRACKING_ACTION,
  TRACKING_FAVORITES_CEL,
  TRACKING_INTERACTION,
} from '../Constants';

export const utagFavoritesSignInPanelDisplayed = ({ VDSID, link_name }) => {
  const interactionType = {
    eventType: TRACKING_ACTION.INTERACTION,
    interaction:
      TRACKING_INTERACTION.FAVORITES_AND_WATCHLIST.FAVORITES_SIGNIN_DISPLAYED,
  };

  const info = {
    pageName: TRACKING_FAVORITES_CEL.SIGN_IN_PAGE,
    VDSID,
    link_name,
  };

  const userInteractionEvent = createUserInteraction(interactionType, info);
  trackEvent(userInteractionEvent);
};
